import { render, staticRenderFns } from "./videoCard.vue?vue&type=template&id=32e963d0&scoped=true&"
import script from "./videoCard.vue?vue&type=script&lang=js&"
export * from "./videoCard.vue?vue&type=script&lang=js&"
import style0 from "./videoCard.vue?vue&type=style&index=0&id=32e963d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e963d0",
  null
  
)

export default component.exports